import {
  getCenterExecute,
  getCenterExecuteV1,
  addCenterExecute,
  updateCenterExecute,
  deleteCenterExecute,
  duplicateCenterExecute,
  changeAssessor,
  editCenterExecuteCaseCompetency,
  getAllCenterExecutePerson,
  getCenterExecuteCase,
  getCenterExecuteCaseCompetencies,
  getCenterExecuteCaseCompetenciesIndicators,
  getCenterExecuteCaseOverview,
  getCenterExecuteCasePersons,
  rebuildCenterExecuteReports,
  rebuildCenterExecuteReport,
  removeCenterExecuteReport,
  removeEvidenceData,
  removeEvidenceDataLog,
  setAssessmentPlan,
  setCenterExecuteAbsent,
  setCenterExecuteCaseCompetencyIndicatorEvidence,
  setCenterExecuteExport,
  setCenterExecuteState,
  setCompetencyIndicatorStatus,
  setComputeCompetencyOverview,
  setParvandehSetAbsent,
  setStartDelay,
  getCenterExecuteExercises,
  setCenterExecuteExercisePrerequisite,
  setChangeGroupStatus,
  setIncompleteCompletion,
  getCenterExecuteScoreExcel,
  rebuildAllReports,
} from "./center-execute-services";
import {
  addCenterExecutePerson,
  updateCenterExecutePerson,
  removeCenterExecutePerson,
  setCenterExecutePersonReport,
} from "./center-execute-person-services";
import {
  addEvidence,
  cloneEvidence,
  deleteEvidence,
  editEvidence,
  getAllSamples,
  getOneEvidence,
} from "./evidence-services";
import {
  createAttachment,
  deleteAttachment,
  getAttachments,
  updateAttachment,
} from "./center-execute-case-attachment-services";
import {
  getCandidateOverview,
  getCompetencyOverview,
  getWashup,
  setCenterExecuteCaseStatus,
  setConclusionFinalScore,
  setFinalScore,
} from "./washup-services";
import {
  getCenterExecuteRoom,
  updateCenterExecuteRoom,
} from "./center-execute-room-services";
import { exportCenterExecuteMeetingBoard } from "./meeting-board-services";
import {
  addCenterExecuteAccess,
  deleteCenterExecuteAccess,
} from "./center-execute-access-services";
import {
  getAttachments as centerExecuteListGetAttachments,
  createAttachment as centerExecuteListCreateAttachment,
  updateAttachment as centerExecuteListUpdateAttachment,
  deleteAttachment as centerExecuteListDeleteAttachment,
} from "./center-execute-attachment-services";
import {
  getAttachments as centerExecuteActivityGetAttachments,
  createAttachment as centerExecuteActivityCreateAttachment,
  updateAttachment as centerExecuteActivityUpdateAttachment,
  deleteAttachment as centerExecuteActivityDeleteAttachment,
} from "./center-execute-activities-attachment-services";

export {
  getOneEvidence,
  addEvidence,
  editEvidence,
  cloneEvidence,
  deleteEvidence,
  getAllSamples,
  getCenterExecute,
  getCenterExecuteV1,
  addCenterExecute,
  updateCenterExecute,
  deleteCenterExecute,
  duplicateCenterExecute,
  getAllCenterExecutePerson,
  setCenterExecuteAbsent,
  setCenterExecuteExport,
  setParvandehSetAbsent,
  getCenterExecuteCase,
  changeAssessor,
  setStartDelay,
  getCenterExecuteExercises,
  setCenterExecuteExercisePrerequisite,
  setChangeGroupStatus,
  setIncompleteCompletion,
  getCenterExecuteScoreExcel,
  rebuildAllReports,
  setAssessmentPlan,
  getCenterExecuteCaseCompetencies,
  getCenterExecuteCasePersons,
  setCompetencyIndicatorStatus,
  setComputeCompetencyOverview,
  getCenterExecuteCaseCompetenciesIndicators,
  setCenterExecuteCaseCompetencyIndicatorEvidence,
  removeEvidenceData,
  removeEvidenceDataLog,
  editCenterExecuteCaseCompetency,
  getCenterExecuteCaseOverview,
  setCenterExecuteState,
  removeCenterExecuteReport,
  rebuildCenterExecuteReports,
  rebuildCenterExecuteReport,
  getWashup,
  getCompetencyOverview,
  setCenterExecuteCaseStatus,
  getCandidateOverview,
  setFinalScore,
  setConclusionFinalScore,
  getAttachments,
  createAttachment,
  updateAttachment,
  deleteAttachment,
  addCenterExecutePerson,
  updateCenterExecutePerson,
  removeCenterExecutePerson,
  setCenterExecutePersonReport,
  getCenterExecuteRoom,
  updateCenterExecuteRoom,
  exportCenterExecuteMeetingBoard,
  addCenterExecuteAccess,
  deleteCenterExecuteAccess,
  centerExecuteListGetAttachments,
  centerExecuteListCreateAttachment,
  centerExecuteListUpdateAttachment,
  centerExecuteListDeleteAttachment,
  centerExecuteActivityGetAttachments,
  centerExecuteActivityCreateAttachment,
  centerExecuteActivityUpdateAttachment,
  centerExecuteActivityDeleteAttachment,
};
